module.exports = __webpack_public_path__ + "static/media/31_tn.15c33944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/31_tn.jpg
// module id = 340
// module chunks = 0